import { fetchData } from './../../utils/data';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, handleAddItem, handleUpdateItem } from "../../utils/data";
import { Article } from "../../types";
import i18n from '../../i18n';
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchArticles = createAsyncThunk("get/article", async () => {
    const data = await fetchData(`Article/getArticles?lang=${lang}`);
    return data;
});
export const fetchArticleDetailsAdmin = createAsyncThunk("get/ArticleDetailsAdmin", async (articleId : number ) => {
    const data = await fetchData(`Article/getArticleWithAllData?articleId=${articleId}`,true);
    return data;
});
export const fetchArticleDetails = createAsyncThunk("get/ArticleDetails", async ({ articleId }: { articleId: number }) => {
    const data = await fetchData(`Article/getArticleDetails?articleId=${articleId}&lang=${lang}`);
    return data;
});
export const addArticle = createAsyncThunk("post/article", async (articleData: any) => {
    await handleAddItem(articleData, "article/addArticle", "POST");
    return articleData;
});
export const updateArticle = createAsyncThunk("PUT/article", async ({ id, data }: { id: number, data: any }) => {
    await handleUpdateItem(data, `article/editArticle?articleId=${id}`, "PUT");
    return data;
});
export const deleteArticle = createAsyncThunk("delete/article", async (id: number) => {
    await deleteItem(`Article/deleteArticle?articleId=`, id);
    return id;
});
interface articleState {
    articles: Article[];
    article: Article | null;
    loading: boolean;
    error: string;
}

const initialState: articleState = {
    articles: [],
    article: null,
    loading: false,
    error: ""
};

const articleSlice = createSlice({
    name: "articleSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchArticles.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchArticles.fulfilled, (state, action) => {
                state.loading = false;
                state.articles = action.payload;
            })
            .addCase(fetchArticleDetails.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchArticleDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.article = action.payload;
            })
            //fetch data for admin
            .addCase(fetchArticleDetailsAdmin.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchArticleDetailsAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.article = action.payload;
            })
            
            // Add
            .addCase(addArticle.fulfilled, (state, action) => {
                state.articles.push(action.payload);
            })

            // Update

            // Delete
            .addCase(deleteArticle.fulfilled, (state, action) => {
                state.articles = state.articles.filter((item) => item.id !== action.payload);
            })
    }
});

export default articleSlice.reducer;
